import React, { useRef, useEffect } from 'react';
import WebViewer from '@pdftron/webviewer';
import './App.css';

const App = () => {
  const viewer = useRef(null);

  // if using a class, equivalent of componentDidMount 
  useEffect(() => {
    WebViewer(
      {
        path: '/webviewer-react-sample/webviewer/lib',
        initialDoc: '/webviewer-react-sample/files/PDFTRON_about.pdf',
      },
      viewer.current,
    ).then((instance) => {
      // const { documentViewer, annotationManager, Annotations } = instance.Core;
      instance.UI.enableElements(['contentEditButton']);
    });
  }, []);

  return (
    <div className="App">
      <div className="header">React sample</div>
      <div className="webviewer" ref={viewer}></div>
    </div>
  );
};

export default App;
